/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-array-index-key */
import moment from 'moment'
import React, { useState, useEffect } from 'react'
import { Tooltip } from '@mui/material'
import { useSelector } from 'react-redux'
import { Modal } from 'components'
import withStyles from '@mui/styles/withStyles'

import ManualAnalysisList from 'components/ManualAnalysisList'
import { get } from 'services/api'

import { BGC_FIELDS } from 'utils/constants/bgcFields'
import {
  APPLICATION_STATUS,
  APPLICATION_TIMELINE_STATUS_STEPS,
  CONSOLIDATED_APPLICATION_STATUS_DESCRIPTION,
  ITEM_STATUS,
} from 'utils/constants/application'
import { buildScore, maskString } from 'utils/functions'
import classNames from 'classnames'
import Timeline from 'components/Timeline'
import Colors from 'utils/Colors'
import {
  showApprovedIcon,
  showDashIcon,
  showDashIcon as showEmptyIcon,
  showErrorIcon,
  showReprovedIcon,
  showWaitingIcon,
} from 'components/CommonIcon'
import _ from 'lodash'
import styles from './styles'
import OpenApplicationButton from './OpenApplicationButton'

const ResumeTable = ({ data, handleOpenModal, reloadData }) => {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)

  const [modal, setModal] = useState(false)
  const [applicationId, setApplicationId] = useState(null)
  const [reviewsSummaries, setReviewsSummaries] = useState({})
  const [loadingReviewsSummary, setLoadingReviewsSummary] = useState(false)

  const waitingReviewApplicationIds = (data || [])
    .filter((application) => application.status === APPLICATION_STATUS.waitingForReview)
    .map((application) => application.uuid)
  const waitingReviewApplicationIdsKey = waitingReviewApplicationIds.join(',')

  const CustomTooltip = withStyles(() => ({
    tooltip: {
      margin: 0,
    },

  }))(Tooltip)

  useEffect(() => {
    let isMounted = true

    const getReviewsSummaries = async () => {
      if (!waitingReviewApplicationIdsKey) {
        setReviewsSummaries({})
        setLoadingReviewsSummary(false)
        return
      }

      setLoadingReviewsSummary(true)
      setReviewsSummaries({})

      try {
        const params = new URLSearchParams()
        waitingReviewApplicationIds.forEach((uuid) => {
          params.append('application_uuids', uuid)
        })

        const response = await get({
          url: '/reviews/summaries',
          token,
          params,
        })

        if (isMounted) {
          const summariesByApplication = Array.isArray(response)
            ? response.reduce((summaries, item) => {
              if (item?.application_uuid) {
                summaries[item.application_uuid] = item.reviews_summary
              }
              return summaries
            }, {})
            : {}

          setReviewsSummaries(summariesByApplication)
        }
      } catch {
        if (isMounted) {
          setReviewsSummaries({})
        }
      } finally {
        if (isMounted) {
          setLoadingReviewsSummary(false)
        }
      }
    }

    getReviewsSummaries()

    return () => {
      isMounted = false
    }
  }, [waitingReviewApplicationIdsKey, token])

  const handleCloseModal = () => {
    setModal(false)
    reloadData()
  }

  const buildBgcFields = (application) => {
    const scoreBoard = application.score_board
    
    const scores = scoreBoard?.scores || []

    const showBgcProcessmentIcon = (item) => {
      const { status, has_issues } = item

      if (application.result === 'REPROVED_BY_DENY_LIST') {
        return showReprovedIcon()
      }
      if (status === ITEM_STATUS.processing) return showWaitingIcon()
      switch (has_issues) {
        case true:
          return showReprovedIcon()
        case false:
          return showApprovedIcon()
        default:
          return showEmptyIcon()
      }
    }

    const showCreditScore = (item) => {
      const key = item.uuid

      if (application.result === 'REPROVED_BY_DENY_LIST') {
        return <td key={key}>{showReprovedIcon()}</td>
      }
      if (item?.status === ITEM_STATUS.processing) {
        return <td key={key}>{showWaitingIcon()}</td>
      }
      if (!item?.reason) {
        return <td key={key}>{showEmptyIcon()}</td>
      }
      const quod_score = parseInt(item?.reason, 10)

      return (
        <td
          key={key}
          style={{
            color: quod_score >= 600 ? Colors.green : Colors.red,
            fontWeight: 550,
          }}
        >
          {quod_score }
        </td>
      )
    }

    try {
      return Object.values(BGC_FIELDS).map((field) => {
        const item = _.find(scores, { type: field })
        if (!item) {
          return null
        }
        if (field === 'job_role' || field === 'occupation_area' || field === 'final_score' || field === 'risk_score') {
          return null
        }
        if (application.result === 'REPROVED_BY_DENY_LIST') {
          return <td key={field}>{showReprovedIcon()}</td>
        }
        if (
          application.status === APPLICATION_STATUS.bgcProcessedMissingCreditAnalysis &&
          (field === BGC_FIELDS.credit_score_data || field === BGC_FIELDS.financial_pendings_data)
        ) {
          return <td key={field}>{showErrorIcon()}</td>
        }
        if (field === BGC_FIELDS.credit_score_data) {
          return showCreditScore(item)
        }
        return <td key={field}>{application.warnings ? showErrorIcon() : showBgcProcessmentIcon(item)}</td>
      })
    } catch (err) {
      console.error(err)
      return <td key="bgc-fields-error">N/A</td>
    }
  }


  const handleOpenManualAnalisys = (selectedApplicationId) => {
    setModal(true)
    setApplicationId(selectedApplicationId)
  }

  const showApplicationStatus = (application) => {
    const getApplicationStatusTextAndStyle = () => {
    switch (application.status) {
      case APPLICATION_STATUS.created:
        return { msg: CONSOLIDATED_APPLICATION_STATUS_DESCRIPTION.created }
      case APPLICATION_STATUS.bgcProcessing:
        return { msg: CONSOLIDATED_APPLICATION_STATUS_DESCRIPTION.bgcProcessing }
      case APPLICATION_STATUS.bgcProcessedMissingCreditAnalysis:
        return { msg: CONSOLIDATED_APPLICATION_STATUS_DESCRIPTION.bgcProcessedMissingCreditAnalysis }
      case APPLICATION_STATUS.waitingForReview:
        return { msg: CONSOLIDATED_APPLICATION_STATUS_DESCRIPTION.waitingForReview }
      case APPLICATION_STATUS.error:
        return { msg: CONSOLIDATED_APPLICATION_STATUS_DESCRIPTION.error, style: { color: Colors.red, fontWeight: 600 } }
      case APPLICATION_STATUS.finished:
        
        if (application.result === 'APPROVED') {
            return {
              msg: CONSOLIDATED_APPLICATION_STATUS_DESCRIPTION.approved,
              style: { color: Colors.green, fontWeight: 700 },
            }
        }
        return { msg: CONSOLIDATED_APPLICATION_STATUS_DESCRIPTION.reproved, style: { color: Colors.red, fontWeight: 700 } }
      default:
        return { msg: application.status }
    }
    }

    const msgAndStyle = getApplicationStatusTextAndStyle()
    return msgAndStyle ? <span style={msgAndStyle.style}>{msgAndStyle.msg}</span> : showEmptyIcon()
  }



  
  useEffect(() => {
    if (applicationId) setModal(true)
  }, [applicationId])

  const showButtonsTableSection = (application) => (
    <div className={classes.detailsContent}>
      <OpenApplicationButton
        application={application}
        onOpenDetails={handleOpenModal}
        onOpenAnalysis={handleOpenManualAnalisys}
        reviewsSummary={reviewsSummaries[application.uuid]}
        loadingReviewsSummary={
          application.status === APPLICATION_STATUS.waitingForReview && loadingReviewsSummary
        }
      />
    </div>
  )

  const showBgcRiskScore = (application) => {
      const { score_board } = application

      if (application.result === 'REPROVED_BY_DENY_LIST') {
        return showReprovedIcon()
      }
      if (application?.candidate?.person?.is_in_deny_list) {
        return showDashIcon()
      }
      if (!score_board) {
        return null
      }
      if (score_board.is_inconsistent) {
        return showErrorIcon()
      }

      if (!score_board.is_complete) {
        return showWaitingIcon()
      }

      if (score_board.final_score !== null && score_board.final_score !== undefined) {
        return (
          <div className={classes.score} style={buildScore(score_board.final_score)}>
            {score_board.final_score.toFixed(1)}
          </div>
        )
      }
      return <div>{showDashIcon()}</div>
    }

  return (
    <React.Fragment>
      <table className={classes.dataTable}>
        <thead>

        <tr>
          <th>Início do Processo</th>
          <th className={classes.nameHeader}>Nome</th>
          <th className={classes.cpfHeader}>CPF</th>
          <th className={classes.scoreHeaders}>Especialidade</th>
          <th className={classes.scoreHeaders}>Senioridade</th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Compliance List
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Mídia Negativa
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            PEP
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Processos Judiciais
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Listas Restritivas
          </th>
          <th className={classNames(classes.iconContent, classes.bgcHeaders)}>
            Pessoa vinculada
          </th>
          <th
            className={classNames(classes.iconContent, classes.scoreHeaders)}
          >
            Participação societária
          </th>
          <th className={classNames(classes.iconContent, classes.rfcHeaders)}>
            Score de crédito
          </th>
          <th className={classNames(classes.iconContent, classes.rfcHeaders)}>
            Pendências financeiras
          </th>
          <th>Score</th>
          <th>Status</th>
          <th>Conteúdo</th>
        </tr>
        </thead>
        <tbody>
        {data ? (
          data.map((application) => {
            const showPersonName = () => {
              const name = application?.candidate?.person?.name
              if (name) {
                return name
              }
              return application?.result === 'REPROVED_BY_DENY_LIST'
                ? showDashIcon()
                : showWaitingIcon()
            }

            return (
              <CustomTooltip
                interactive="true"
                key={application.uuid}
                classes={{ tooltip: classes.noMaxWidth }}
                PopperProps={{ style: { zIndex: 0 } }}
                title={
                  <Timeline
                    actualStep='Aplicação iniciada'
                    steps={APPLICATION_TIMELINE_STATUS_STEPS}
                  />
                }
              >
                <tr className={classes.cursorPointer}>
                  <td>
                    {moment(application.created).format('DD/MM/YYYY')}
                    <br />
                    {moment(application.created).format('HH:mm')}
                  </td>

                  <td>{showPersonName()}</td>

                  <td>
                    {application.candidate.person.cpf
                      ? maskString(application.candidate.person.cpf, 'cpf')
                      : showWaitingIcon()}
                  </td>

                  <td>
                    {application.specialty
                      ? application.specialty.split(' | ', 1)[0]
                      : application.specialty?.warnings
                        ? showErrorIcon()
                        : showWaitingIcon()}
                  </td>

                  <td>
                    {application.seniority
                      ? application.seniority.split(' | ', 1)[0]
                      : application.seniority?.warnings
                        ? showErrorIcon()
                        : showWaitingIcon()}
                  </td>

                  {buildBgcFields(application)}

                  <td>{showBgcRiskScore(application)}</td>

                  <td>{showApplicationStatus(application)}</td>

                  <td>{showButtonsTableSection(application)}</td>
                </tr>
              </CustomTooltip>
            )
          })
        ) : (
          <tr>
            <td colSpan="20" className={classes.emptyTable}>
              Nenhum resultado encontrado
            </td>
          </tr>
        )}
        </tbody>
      </table>

      <Modal
        open={modal}
        onClose={() => handleCloseModal()}
        title='Revisão Manual de Background Check'
      >
        <ManualAnalysisList
          applicationId={applicationId}
        />
      </Modal>
    </React.Fragment>
  )
}

export default ResumeTable
